const overdueDateRegex = /\d{4}-\d{2}-\d{2}/;

export const parseOverdueDate = ({ overdueDate }: { overdueDate: string }) => {
  const datePart = overdueDate.split(' ')[0];
  const match = datePart.match(overdueDateRegex);

  if (!match) {
    return null;
  }

  return match[0];
};

export const formatOverdueDate = ({
  locales,
  overdueDate,
}: {
  locales?: Intl.LocalesArgument;
  overdueDate: string;
}) => {
  const parsedDate = new Date(overdueDate);

  const formattedDate = parsedDate.toLocaleDateString(locales, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return formattedDate;
};
